import request from "@/libs/request";
import { UsageStatisticsRequest, UsageStatisticsResponse } from "@/types/usage";

// 사용 현황 통계 조회
export const readUsageStatistics = async ({
  start_date,
  end_date,
}: UsageStatisticsRequest): Promise<UsageStatisticsResponse> => {
  const response = await request.get<UsageStatisticsResponse>(
    `/statistics/usage`,
    { params: { start_date, end_date } }
  );
  return response.data;
};
